<template>
    <div v-if="value.path" class="flex-1">
        <video-display v-if="value.isVideo()" :src="'/api/proxy?url='+value.path"></video-display>
        <img v-else :src="'/api/proxy?url='+value.path" class="mx-auto">
    </div>
    <alert v-else :title="'Ordet [' + value + '] har ingen illustrasjoner og andre visninger er ikke støttet enda'">
        <ul role="list" class="list-disc pl-5 space-y-1">
            <li v-if="word && word.signs && word.signs.length > 1">Prøv et annet synonym ved å trykke øverst til høyre i denne boksen</li>
            <li>Prøv å skrive inn et synonym</li>
            <li>Prøv å omformuler setningen</li>
        </ul>
    </alert>
</template>

<script>
export default {
    props: {
        value: {
            required: true,
        },
    },
}
</script>
